var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 75,
    viewBox: "0 0 53 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0843 31.7698L10.4226 45.4045L29.0902 50.2974L42.7547 36.6733L24.0843 31.7698Z",
    fill: "#FE2C55",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4224 45.4042L29.0899 50.2971L34.0844 68.7825L15.414 63.8791L10.4224 45.4042Z",
    fill: "#FE2C55",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7542 36.6711L29.0903 50.2975L34.0848 68.783L47.7636 55.2116L42.7542 36.6711Z",
    fill: "#FE2C55",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6204 35.9672C12.9793 36.1749 13.4383 36.053 13.6455 35.6948L17.0231 29.8588C17.2304 29.5006 17.1074 29.042 16.7486 28.8343C16.3897 28.6266 15.9307 28.7485 15.7235 29.1066L12.7212 34.2942L7.52276 31.2857C7.16389 31.078 6.70494 31.1999 6.49767 31.5581C6.29041 31.9162 6.41332 32.3749 6.77219 32.5826L12.6204 35.9672ZM7.09449 16.1928L12.2709 35.5114L13.7206 35.1262L8.54418 15.8076L7.09449 16.1928Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7611 29.8633C34.1199 30.071 34.5789 29.9491 34.7861 29.5909L38.1637 23.7549C38.371 23.3968 38.2481 22.9381 37.8892 22.7304C37.5303 22.5227 37.0714 22.6446 36.8641 23.0028L33.8618 28.1904L28.6634 25.1818C28.3045 24.9741 27.8456 25.0961 27.6383 25.4542C27.431 25.8123 27.5539 26.271 27.9128 26.4787L33.7611 29.8633ZM28.2351 10.089L33.4115 29.4075L34.8612 29.0223L29.6848 9.70376L28.2351 10.089Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4608 26.5383C21.8196 26.746 22.2786 26.624 22.4859 26.2659L25.8634 20.4298C26.0707 20.0717 25.9478 19.613 25.5889 19.4053C25.23 19.1976 24.7711 19.3196 24.5638 19.6777L21.5615 24.8653L16.3631 21.8568C16.0042 21.6491 15.5453 21.771 15.338 22.1292C15.1307 22.4873 15.2536 22.946 15.6125 23.1537L21.4608 26.5383ZM15.9348 6.76392L21.1112 26.0824L22.5609 25.6972L17.3845 6.37872L15.9348 6.76392Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 67,
    fill: "white",
    transform: "translate(0 10) rotate(-15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/dropIcon.edf626d1.svg";
export { ForwardRef as ReactComponent };